import { Gewerk } from '@myapp/contract'
import { EntitySearchSelect } from '../../../shared/ui/search/EntitySearchSelect/EntitySearchSelect'
import { useGewerkeInfiniteQuery } from '../api/queries/useGewerkeInfiniteQuery'
import { useGewerkDetail } from '../api/queries/useGewerkDetail'

interface GewerkSearchSelectProps {
  value: number | null | undefined
  onChange: (id: number | null, item?: Gewerk) => void
  disabled?: boolean
  readOnly?: boolean
  hasError?: boolean
  className?: string
  placeholder?: string
}

export function GewerkSearchSelect({
  value,
  onChange,
  disabled,
  readOnly,
  hasError,
  className,
  placeholder = 'Gewerk suchen…',
}: GewerkSearchSelectProps) {
  return (
    <EntitySearchSelect<Gewerk>
      value={value}
      onChange={onChange}
      useInfiniteHook={useGewerkeInfiniteQuery}
      useDetailHook={useGewerkDetail}
      searchParamName="search"
      getLabel={(g) => g.text}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      hasError={hasError}
      className={className}
    />
  )
}
